<template>
  <div >
    <vx-card>
      <div slot="no-body" class="flex justify-center text-center">
        <img  src="@/assets/images/banner_01.png" alt="content-img" class="responsive card-img-top">
      </div>
    </vx-card>
      <br>
    <vx-card>
      <div slot="no-body" class="flex justify-center text-center">
        <img src="@/assets/images/banner_02.png" alt="content-img" class="responsive card-img-top">
      </div>
    </vx-card>
    <br>
    
    <vx-card>
      <div slot="no-body" class="flex justify-center text-center">
        <img src="@/assets/images/banner_03.png" alt="content-img" class="responsive card-img-top">
      </div>
    </vx-card>
  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      
    }
  },
  watch: {
  },
  computed: {
   
  },
  methods: {
  },
  created () {
  }
}

</script>

